import { module } from 'angular';

import { ChosenDirectiveAjs, default as chosenDirectiveName } from './chosen.directive.ajs';

export default module('contact.commons.toolbox.chosen', []).directive(chosenDirectiveName, ['search', ChosenDirectiveAjs]).name;
